import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { ReportBugDialogComponent } from './components/report-bug-dialog/report-bug-dialog.component';
import { ScreenshotEditorDialogComponent } from './components/screenshot-editor-dialog/screenshot-editor-dialog.component';
import { ReportBugButtonComponent } from './components/report-bug-button/report-bug-button.component';
import { BugReportErrorHandler } from './services/error-buffer.service';
import { HttpFailureInterceptor } from './services/http-failure.interceptor';

/**
 * Reporting a problem, and the diagnostics that make a report worth reading.
 *
 * Imported eagerly by `AppModule` rather than lazy-loaded. The error handler and the failure
 * interceptor have to be in place from the first navigation, because the errors most worth
 * capturing are the ones that happen before the user gets anywhere.
 */
@NgModule({
  declarations: [ReportBugButtonComponent, ReportBugDialogComponent, ScreenshotEditorDialogComponent],
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, MatSnackBarModule, TranslateModule],
  exports: [ReportBugButtonComponent],
  providers: [
    { provide: ErrorHandler, useClass: BugReportErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: HttpFailureInterceptor, multi: true },
  ],
})
export class BugReportModule {}
